import { Grid } from '@mui/joy';
import React from 'react';
import { Route, Routes } from 'react-router';
import Home from './AIchatbot/Home';
import ChatbotDocs from './AIchatbot/Docs';
import Questions from './AIchatbot/Questions';
import AiJobDesc from './AIchatbot/AI-AssistedJobDescription/AiJobDesc';
import JobDescription from './AIchatbot/JobDescription';
import AI_Add_Resume from './AIchatbot/AI_AssistedResumeBuilder/AI_Add_Resume';
import DragSwapBoxes from './AIchatbot/AI_AssistedResumeBuilder/AI_Assisted_Resume_Builder_usingdnd';

const DashBoardsFields = () => {
  return (
    <div>
      <Grid item xs={12} sx={{ marginTop: '30px' }}>
        <Routes>
          <Route path={'/'} element={<Home />} />
          <Route path="/docs" element={<ChatbotDocs />} />
          <Route path="/coursefinder" element={<Questions />} />
          <Route path="/ai-job-description" element={<AiJobDesc />} />
          <Route path="/jobdescription" element={<JobDescription />} />
          <Route path="/airesumebuilder" element={<AI_Add_Resume />} />
          <Route path="/aigeneratedresume" element={<DragSwapBoxes />} />
        </Routes>
      </Grid>
    </div>
  );
};

export default DashBoardsFields;
